export function encodePayload(payload = {}) {
    const definedData = {};
    Object.entries(payload).forEach(([key, value]) => {
        if (value != null) {
            definedData[key] = value;
        }
    });
    return encodeURIComponent(b64EncodeUnicode(JSON.stringify(definedData)));
}
/**
 * We cannot pass plain JS string into BTOA:
 *
 * Base64, by design, expects binary data as its input. In terms of JavaScript strings,
 * this means strings in which each character occupies only one byte.
 * So if you pass a string into btoa() containing characters that occupy more than one byte, you will get an error, because this is not considered binary data.
 *
 * So, As seen on SO we use this solution:
 * https://stackoverflow.com/a/30106551/7118711
 */
export function b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (_match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
    }));
}
